import axios from "axios";
import api from "../api/index";

const CREATE_USER_REQUEST = "FARMAKOM/EDITOR/CREATE_USER_REQUEST";
const CREATE_USER_SUCCESS = "FARMAKOM/EDITOR/CREATE_USER_SUCCESS";
const CREATE_USER_FAILURE = "FARMAKOM/EDITOR/CREATE_USER_FAILURE";

const LOGIN_USER_REQUEST = "FARMAKOM/EDITOR/LOGIN_USER_REQUEST";
const LOGIN_USER_SUCCESS = "FARMAKOM/EDITOR/LOGIN_USER_SUCCESS";
const LOGIN_USER_FAILURE = "FARMAKOM/EDITOR/LOGIN_USER_FAILURE";

const GET_USER_REQUEST = "FARMAKOM/EDITOR/GET_USER_REQUEST";
const GET_USER_SUCCESS = "FARMAKOM/EDITOR/GET_USER_SUCCESS";
const GET_USER_FAILURE = "FARMAKOM/EDITOR/GET_USER_FAILURE";

const UPDATE_USER_REQUEST = "FARMAKOM/EDITOR/UPDATE_USER_REQUEST";
const UPDATE_USER_SUCCESS = "FARMAKOM/EDITOR/UPDATE_USER_SUCCESS";
const UPDATE_USER_FAILURE = "FARMAKOM/EDITOR/UPDATE_USER_FAILURE";

const DELETE_USER_REQUEST = "FARMAKOM/EDITOR/DELETE_USER_REQUEST";
const DELETE_USER_SUCCESS = "FARMAKOM/EDITOR/DELETE_USER_SUCCESS";
const DELETE_USER_FAILURE = "FARMAKOM/EDITOR/DELETE_USER_FAILURE";

const LOGOUT_USER = "FARMAKOM/EDITOR/LOGOUT_USER";

const initialState = {
  loading: false,
  error: false,
  data: {
    authToken: null,
    refreshToken: null,
    user: null,
    expiresIn: null,
  },
};

export default function reducerStores(state = initialState, action) {
  switch (action.type) {
    case CREATE_USER_REQUEST:
      return { ...state, loading: true, error: false };
    case CREATE_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    case CREATE_USER_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case LOGIN_USER_REQUEST:
      return { ...state, loading: true, error: false };
    case LOGIN_USER_SUCCESS:
      return { ...state, loading: false, data: action.payload };
    case LOGIN_USER_FAILURE:
      return {
        ...state,
        loading: false,
        data: initialState.data,
        error: action.payload,
      };
    case GET_USER_REQUEST:
      return { ...state, loading: true, error: false };
    case GET_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        data: {
          ...state.data,
          user: action.payload,
        },
      };
    case GET_USER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case UPDATE_USER_REQUEST:
      return { ...state, loading: true, error: false };
    case UPDATE_USER_SUCCESS:
      return {
        ...state,
        loading: false,
        data: {
          ...state.data,
          user: {
            ...state.data.user,
            ...action.payload,
          },
        },
      };
    case UPDATE_USER_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case DELETE_USER_REQUEST:
      return { ...state, loading: true, error: false };
    case DELETE_USER_SUCCESS:
      return { ...state, loading: false, data: initialState.data };
    case DELETE_USER_FAILURE:
      return { ...state, loading: false, error: action.payload };
    case LOGOUT_USER:
      return { ...initialState };
    default:
      return state;
  }
}

export const createUser = (userData) => {
  return async (dispatch) => {
    dispatch({
      type: CREATE_USER_REQUEST,
    });
    try {
      const { url, method, headers, data } = api.signUp(userData);

      const newUser = await axios({
        url,
        method,
        headers,
        data,
      });

      dispatch({
        type: CREATE_USER_SUCCESS,
        payload: newUser.data,
      });

      localStorage.setItem("user", JSON.stringify(newUser.data));
    } catch (error) {
      // console.log(error);
      dispatch({
        type: CREATE_USER_FAILURE,
        payload: error,
      });
    }
  };
};

export const loginUser = (credentials) => {
  return async (dispatch) => {
    dispatch({
      type: LOGIN_USER_REQUEST,
    });
    // console.log("dispached", credentials);

    try {
      if (!credentials) {
        const userLs = localStorage.getItem("user");
        if (userLs) {
          const user = JSON.parse(userLs);
          dispatch({
            type: LOGIN_USER_SUCCESS,
            payload: user,
          });
        } else {
          // console.log("OKOK");
          dispatch({
            type: LOGIN_USER_FAILURE,
            payload: "no_user_in_local_storage",
          });
        }
      } else {
        const { url, method, headers, data } = api.login(credentials);

        const user = await axios({
          url,
          method,
          headers,
          data,
        });

        // console.log(user);
        if (user) {
          dispatch({
            type: LOGIN_USER_SUCCESS,
            payload: user.data,
          });

          localStorage.setItem("user", JSON.stringify(user.data));
        } else {
          dispatch({
            type: LOGIN_USER_FAILURE,
            payload: "no_user_found",
          });
        }
      }
    } catch (error) {
      // console.log("error", error);

      dispatch({
        type: LOGIN_USER_FAILURE,
        payload: "error_login",
      });
    }
  };
};

export const getUser = () => {
  return async (dispatch) => {
    dispatch({
      type: GET_USER_REQUEST,
    });
    try {
      const { url, method, headers } = api.getUser();

      const user = await axios({
        url,
        method,
        headers,
      });

      if (user) {
        dispatch({
          type: GET_USER_SUCCESS,
          payload: user.data,
        });
      } else {
        dispatch({
          type: GET_USER_FAILURE,
          payload: "Couldn't find user",
        });
      }
    } catch (error) {
      dispatch({
        type: GET_USER_FAILURE,
        payload: error,
      });
    }
  };
};

export const updateUser = (userUpdates) => {
  return async (dispatch) => {
    dispatch({
      type: UPDATE_USER_REQUEST,
    });
    try {
      const { url, method, headers, data } = api.updateUser(userUpdates);

      const updatedUser = await axios({
        url,
        method,
        headers,
        data,
      });

      if (updatedUser) {
        // console.log("res", updatedUser.data);
        const userLs = localStorage.getItem("user");
        const user = JSON.parse(userLs);
        localStorage.removeItem("user");
        localStorage.setItem(
          "user",
          JSON.stringify({
            ...user,
            user: {
              ...user.user,
              ...updatedUser.data,
            },
          })
        );
        dispatch({
          type: UPDATE_USER_SUCCESS,
          payload: updatedUser.data,
        });
      } else {
        dispatch({
          type: UPDATE_USER_FAILURE,
          payload: "Couldn't update user",
        });
      }
    } catch (error) {
      // console.log(error);
      dispatch({
        type: UPDATE_USER_FAILURE,
        payload: error,
      });
    }
  };
};

export const deleteUser = () => {
  return async (dispatch) => {
    dispatch({
      type: DELETE_USER_REQUEST,
    });
    try {
      const { url, method, headers } = api.deleteUser();

      const deletedUser = await axios({
        url,
        method,
        headers,
      });

      if (deletedUser) {
        dispatch({
          type: DELETE_USER_SUCCESS,
        });

        localStorage.removeItem("user");
      } else {
        dispatch({
          type: DELETE_USER_FAILURE,
          payload: "Couldn't delete user",
        });
      }
    } catch (error) {
      // console.log(error);
      dispatch({
        type: DELETE_USER_FAILURE,
        payload: error,
      });
    }
  };
};

export const logout = () => {
  return async (dispatch) => {
    dispatch({
      type: LOGOUT_USER,
    });

    localStorage.removeItem("user");
  };
};
